import { createDraftSafeSelector, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { GlobalState } from '@store'
import {
  AgentCommissionPreview,
  AgentCommissionSettlement,
  AgentOption,
  CreateAgentSettlementPayload,
  LoadAgentCommissionPayload,
  MutateAgentSettlementPayload
} from '../types'

interface State {
  agents: AgentOption[]
  preview?: AgentCommissionPreview
  selectedSettlement?: AgentCommissionSettlement
  settlements: AgentCommissionSettlement[]
  loading: boolean
  mutating: boolean
  error: string
  success: string
}
const initialState: State = {
  agents: [],
  settlements: [],
  loading: false,
  mutating: false,
  error: '',
  success: ''
}

const slice = createSlice({
  name: 'agentCommissions',
  initialState,
  reducers: {
    loadAgents: state => state,
    agentsLoaded: (state, action: PayloadAction<AgentOption[]>) => {
      state.agents = action.payload
    },
    loadAgentCommission: (state, _action: PayloadAction<LoadAgentCommissionPayload>) => {
      state.loading = true
      state.error = ''
    },
    agentCommissionLoaded: (
      state,
      action: PayloadAction<{
        preview: AgentCommissionPreview
        settlements: AgentCommissionSettlement[]
      }>
    ) => {
      state.loading = false
      state.preview = action.payload.preview
      state.settlements = action.payload.settlements
    },
    loadSettlementDetail: (state, _action: PayloadAction<string>) => {
      state.loading = true
    },
    settlementDetailLoaded: (state, action: PayloadAction<AgentCommissionSettlement>) => {
      state.loading = false
      state.selectedSettlement = action.payload
    },
    clearSettlementDetail: state => {
      state.selectedSettlement = undefined
    },
    createAgentSettlement: (state, _action: PayloadAction<CreateAgentSettlementPayload>) => {
      state.mutating = true
      state.error = ''
      state.success = ''
    },
    payAgentSettlement: (state, _action: PayloadAction<MutateAgentSettlementPayload>) => {
      state.mutating = true
      state.error = ''
      state.success = ''
    },
    cancelAgentSettlement: (state, _action: PayloadAction<MutateAgentSettlementPayload>) => {
      state.mutating = true
      state.error = ''
      state.success = ''
    },
    mutationDone: (state, action: PayloadAction<string>) => {
      state.mutating = false
      state.success = action.payload
    },
    requestFailed: (state, action: PayloadAction<string>) => {
      state.loading = false
      state.mutating = false
      state.error = action.payload
    },
    clearMessages: state => {
      state.error = ''
      state.success = ''
    },
    clearAgentCommissions: () => initialState
  }
})
export const selectAgentCommissions = createDraftSafeSelector(
  [(state: GlobalState) => state.agentCommissions],
  state => state
)
export const {
  loadAgents,
  agentsLoaded,
  loadAgentCommission,
  agentCommissionLoaded,
  loadSettlementDetail,
  settlementDetailLoaded,
  clearSettlementDetail,
  createAgentSettlement,
  payAgentSettlement,
  cancelAgentSettlement,
  mutationDone,
  requestFailed,
  clearMessages,
  clearAgentCommissions
} = slice.actions
export default slice.reducer
